import { useContext, useEffect, useMemo, useState } from "react";
import { useSettings } from "@utils/hooks/useMe";
import { useAuth } from "@utils/hooks/useAuth";
import { MinerContext, useMinerContext } from "../../MinerContext";
import { IMinerRowMoreSettingsProps } from "./MinerRowMoreSettings.props";
import { SocketContext } from "@components/Context/SocketContext";
import { SocketEventTypes, UserSettingEvent } from "@services/http/socket/responses";

export default function useMinerMoreSettingsControl(
  props?: IMinerRowMoreSettingsProps
) {
  const auth = useAuth();
  const context = useContext(MinerContext);
  const {
    addMessageListener,
    removeMessageListener,
  } = useContext(SocketContext);
  const {
    updateMinerAllSettings,
  } = useMinerContext();

  const settings = useSettings();
  const miner = props?.miner || context.miner;

  const [adminPercent, setAdminPercent] = useState<number>(miner.proof);

  const hasAdminPercent = useMemo((): boolean => {
    if (adminPercent && adminPercent > 0 && adminPercent <= 100) {
      return true;
    }
    return false;
  }, [adminPercent]);

  const getAdminMiningSettingName = useMemo((): string | undefined => {
    return settings.find((item) => item.id === Number(miner.admin_mining_setting))?.name;
  }, [settings, miner.admin_mining_setting]);

  useEffect(() => {
    addMessageListener(SocketEventTypes.USER_SETTING, handleUserSetting);
    return () => {
      removeMessageListener(SocketEventTypes.USER_SETTING, handleUserSetting);
    };
    function handleUserSetting(e: any) {
      const data = ((e as any).event as UserSettingEvent);
      updateMinerAllSettings(data);
    }
  }, []);

  return {
    isAdmin: auth.isAdmin,
    miner,
    adminPercent,
    adminMiningPoolSettingName: getAdminMiningSettingName,
    hasAdminPercent,

    setAdminPercent,
  };
}
